import { Component, OnInit, ViewChild } from '@angular/core';
import { MasterDataService } from '../../Services/MasterDataService';
import { AppSettings } from '../../Library/AppSettings';
import { APIServiceConnector } from '../../Services/APIServiceConnector';
import { BaseComponent } from '../../Library/BaseComponent';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbActiveModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { MessagingService } from '../../Services/MessagingService';
import { StaffMessageRequest, ComplainRegister } from '../../Models/RequestModels';
import { SendMessageDestinationTypes, AuthActionCodes, JobOperationActions, EntityCodes } from '../../Models/EnumModels';
import { GenericMaster, PropertyBasicInfo } from '../../Models/GlobalEntities';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ComplainService } from '../../Services/ComplainService';

@Component({
    selector: 'SendMsg',
    templateUrl: './SendMsg.html'
})
export class SendMsg extends BaseComponent implements OnInit {
    @ViewChild('content') content;
    ModalRef: NgbModalRef;
    Model: StaffMessageRequest;
    PropertyId: number;
    _SendMessageDestinationTypes = SendMessageDestinationTypes;
    StaffListModel: Array<GenericMaster> = [];
    GroupListModel: Array<GenericMaster> = [];
    lstProperties: Array<PropertyBasicInfo> = [];
    Selectable: boolean = true;
    EntityId: number = null;
    JobData: any;

    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, public modalService: NgbModal, public apiService: APIServiceConnector, private messagingService: MessagingService, public complainService: ComplainService) {
        super(translate, toastr, route, router, masterService);
    }

    ngOnInit(): void {
        //this.PropertyId = this.masterService.LoggedInUserData.PropertyId;
        this.Model = new StaffMessageRequest();
        this.Model.SetDefaults();
    }

    SetMasters(): void {
        this.StaffListModel = this.masterService.GetStaff(this.Model.PropertyId);
        let idx = this.StaffListModel.findIndex(a => a.Id == this.masterService.LoggedInUserData.StaffId);
        if (idx >= 0)
            this.StaffListModel.splice(idx, 1);

        this.GroupListModel = this.masterService.GetGroups(this.Model.PropertyId);
    }

    onPropertyChange(): void {
        this.SetMasters();
        this.Model.StaffId = 0;
        this.Model.GroupId = 0;
        if (this.CheckAuth_Dept_Action(this.Model.PropertyId, 0, this._AuthActionCodes.StaffMessage))
            this.Model.SendMessageDestinationType = SendMessageDestinationTypes.Staff;
        else
            this.Model.SendMessageDestinationType = SendMessageDestinationTypes.Group;
    }


    SetDefaults(): void {
        this.Selectable = true;
        let ngbModalOptions: NgbModalOptions = {
            backdrop : 'static',
            size: 'lg', 
            centered: true
        };
        this.ModalRef = this.modalService.open(this.content, ngbModalOptions);
        this.ClearErrors();
        this.Model = new StaffMessageRequest();
        this.Model.SetDefaults();
        if (this.lstProperties.findIndex(a => a.PropertyId == this.masterService.ActivePropertyID) >= 0) {
            this.Model.PropertyId = this.masterService.ActivePropertyID;
        }
        else {
            this.Model.PropertyId = this.lstProperties[0].PropertyId;
        }
        this.SetMasters();
        if (this.CheckAuth_Dept_Action(this.Model.PropertyId, 0, this._AuthActionCodes.StaffMessage))
            this.Model.SendMessageDestinationType = SendMessageDestinationTypes.Staff;
        else
            this.Model.SendMessageDestinationType = SendMessageDestinationTypes.Group;
    }

    Open(EntityId: number, EntityCode:string, StaffId: number, PropertyId: number, JobData:any): void {
        if (JobData) {
            this.JobData = JobData
        }
        
        this.lstProperties = this.masterService.GetProperties_ActionCombo(AuthActionCodes.GroupMessage, AuthActionCodes.StaffMessage);
        if (this.lstProperties.length > 0) {
            if (this.lstProperties.findIndex(a => a.PropertyId == this.masterService.ActivePropertyID) >= 0) {
                this.Model.PropertyId = this.masterService.ActivePropertyID;
            }
            else {
                this.Model.PropertyId = this.lstProperties[0].PropertyId;
            }
            this.SetDefaults();
        }

        if (PropertyId != null) {
            this.Model.PropertyId = PropertyId;
            this.SetMasters();
        }


        if (StaffId != null) {
            this.Model.StaffId = StaffId;
            this.Selectable = false;
            this.Model.SendMessageDestinationType = SendMessageDestinationTypes.Staff;
            this.Model.EntityId = EntityId;
            this.Model.EntityCode = EntityCode;
        }
    }

    Transform(): void {
        if (this.Model == null)
            return;

        if (this.Model.SendMessageDestinationType != null) {
            switch (this.Model.SendMessageDestinationType) {
                case SendMessageDestinationTypes.Group:
                    this.Model.StaffId = null;
                    break;
                case SendMessageDestinationTypes.Staff:
                    this.Model.GroupId = null;
                    break;
            }
        }  
    }
    
    SendMessage(): void {
        this.ClearErrors();

        this.Transform();

        this.Validate();
        if (this.HasErrors)
            return;

        if (this.Model.EntityId != null) {
            let cr = new ComplainRegister();
            cr.LastActionRemarks = this.Model.Message;
            cr.Operation = JobOperationActions.SendMessage;
            cr.ComplainId = this.Model.EntityId;
            cr.PropertyId = this.Model.PropertyId;

            this.complainService.Complain_Update(cr).then(data => {
                this.GetMultilingualToast('TS.TS_MSG_SENT_SUCCESS', 'success');
                this.ModalRef.close();
            });
        }
        else {
                this.messagingService.StaffMessage(this.Model).then(data => {
                    this.FromBaseResponse(data);
                    if (this.HasErrors) {
                        return;
                    }

                    this.GetMultilingualToast('TS.TS_MSG_SENT_SUCCESS', 'success');
                    this.ModalRef.close();

                    //this.SetDefaults();
                });
        }

        
    }

    Validate(): void {
        switch (this.Model.SendMessageDestinationType) {
            case SendMessageDestinationTypes.Staff:
                if (this.Model.StaffId == null || this.Model.StaffId <= 0)
                    this.AddError('ERR.ERR_SELECT_STAFF');
                break;
            case SendMessageDestinationTypes.Group:
                if (this.Model.GroupId == null || this.Model.GroupId <= 0)
                    this.AddError('ERR.ERR_SELECT_GROUP');
                break;
        }

        if (this.Model.Message == null || this.Model.Message.trim().length <= 0)
            this.AddError('ERR.ERR_ENTER_MSG');

        if (this.Model.Message && this.Model.Message.length > 1000)
            this.AddError('ERR.ERR_MSG_LENGTH_1000');
    }
}
